import React from 'react'
import { Banner } from '@odiupsk/up-api-client'
import styled, { createGlobalStyle } from 'styled-components'
import Carousel from 'react-multi-carousel'
import { ButtonLink, Icon } from '../../ui-kit'

const Global = createGlobalStyle`
  .overlay--fill {
    position: relative;
    display: flex;
    align-items: initial;
    justify-content: initial;
    flex: 0 0 100%;
  }

  .card-content--fill {
    flex: 1 0 100%;
  }

  .carouselContainer {
    height: auto;
    width: 100%;
  }

  .carouselContainer .card {
    margin-bottom: 0;
  }
  
  .carouselContainer [class*="grid__col--"] {
    padding-left: 0;
    padding-right: 0;
  }

  .carouselContainer .react-multi-carousel-dot-list {
    bottom: 20px;
    max-width: 350px;
    margin: 0 auto;
    
    @media screen and (min-width: 1024px) {
     bottom: 15px;
    }
  }

  .carouselContainer .react-multi-carousel-dot button {
    border: none;
    width: 10px;
    height: 10px;
    background-color: rgba(255, 255, 255, 0.5);

    @media screen and (min-width: 1024px) {
      width: 8px;
      height: 8px;
    }
  }
  .carouselContainer .react-multi-carousel-dot--active button {
    background-color: rgba(255, 255, 255, 1);
  }

  @media screen and (max-width: 992px) {
    .carouselContainer .hide-below-lg {
      display: none;
    }
  }

  .carouselContainer .react-multiple-carousel__arrow {
    visibility: hidden;
    opacity: 0;
    transition: all 200ms linear;
  }

  .carouselContainer:hover .react-multiple-carousel__arrow {
    visibility: visible;
    opacity: 0.9;
  }

   @media screen and (max-width: 768px) {
    .carouselContainer .react-multiple-carousel__arrow {
      display: none;
    }
  }

  .carouselContainer .card__content {
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    .carouselContainer .card__content .grid__col--auto {
      padding: 1rem;
    }
  }
  @media screen and (min-width: 768px) {
    .carouselContainer .card__content .grid__col--auto {
      padding-top: 0rem;
      padding-bottom: 0rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }
`
const BannerGrid = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  @media screen and (max-width: 400px) {
    min-height: 300px;
  }
  @media screen and (min-width: 400px) and (max-width: 576px) {
    min-height: 280px;
  }

  @media screen and (max-width: 768px) {
    position: relative;
  }

  @media screen and (min-width: 576px) and (max-width: 768px) {
    min-height: 200px;
  }

  @media screen and (min-width: 768px) and (max-width: 1300px) {
    max-height: 230px;
  }

  @media screen and (min-width: 1300px) {
    max-height: 175px;
  }

  @media screen and (min-width: 768px) {
    position: relative;
  }
`
const BannerContent = styled.div`
  background-color: rgba(111, 167, 160, 0.9);
  width: 100%;
  height: 100%;

  padding: 1rem;

  @media screen and (max-width: 768px) {
    position: absolute;
    z-index: 500;
  }

  @media screen and (min-width: 768px) {
    width: 72%;
    padding-top: 1.5rem;
    padding-right: 3rem;
    padding-left: 3.5rem;
    background-color: rgba(111, 167, 160, 1);
  }
`
const BannerImage = styled.div`
  width: 100%;
  height: 100%;

  @media screen and (max-width: 768px) {
    z-index: 300;
    position: absolute;
  }

  @media screen and (min-width: 768px) {
    width: 28%;
    position: relative;
  }
`

const BannerTopWithTurqouiseBackground = (props: Banner) => (
  <BannerGrid>
    <BannerContent>
      <h3 className="h5 text-color-white">{props.title}</h3>
      <p className="text-color-white" dangerouslySetInnerHTML={{ __html: props.perex! }} />
      <ButtonLink
        style={{ paddingLeft: 0 }}
        className="text-color-white mb-none"
        target={props.link_new_window ? '_blank' : ''}
        href={props.link_url}
        size="tiny"
        space="condensed">
        {props.link_text}
        <Icon name="chevron-right" size="medium" className="icon--right" />
      </ButtonLink>
    </BannerContent>
    <BannerImage>
      {[...Array(2)].map((_, i) => (
        <div
          key={i.toString()}
          style={{
            position: 'absolute',
            background: 'linear-gradient(to right, rgba(111, 167, 160, 1), rgba(255, 255, 255, 0))',
            width: '200px',
            height: '100%',
            left: '-2px',
          }}
        />
      ))}
      <img
        style={{
          width: '100%',
          maxHeight: '100%',
          height: 'auto',
          objectFit: 'cover',
        }}
        src={props.images.image!['1x']}
        alt=""
      />
    </BannerImage>
  </BannerGrid>
)

export const HeaderBanners: React.FC<{
  banners: Banner[]
}> = ({ banners }) => {
  const bannersWithTurqouiseBackground = banners.filter(
    data => data.layout === 'dashboard-top-with-turquoise-background'
  )
  const allowControls = bannersWithTurqouiseBackground.length > 1

  const sliderControls = allowControls
    ? {
        swipeable: true,
        draggable: true,
        infinite: true,
        keyBoardControl: true,
        arrows: true,
        showDots: true,
        autoPlay: bannersWithTurqouiseBackground.length >= 2,
        autoPlaySpeed: 5000,
      }
    : {}

  const responsive = {
    desktop: {
      breakpoint: {
        max: 4000,
        min: 992,
      },
      items: 1,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0,
      },
      items: 1,
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464,
      },
      items: 1,
    },
  }

  if (bannersWithTurqouiseBackground.length === 0) {
    return null
  }

  return (
    <>
      <Global />
      <Carousel
        additionalTransfrom={0}
        responsive={responsive}
        slidesToSlide={1}
        minimumTouchDrag={80}
        renderDotsOutside={false}
        focusOnSelect={false}
        autoPlaySpeed={999999}
        autoPlay={false}
        centerMode={false}
        renderButtonGroupOutside={false}
        containerClass="carouselContainer"
        {...sliderControls}
        ssr>
        {bannersWithTurqouiseBackground.map((data, id) => (
          <BannerTopWithTurqouiseBackground key={id.toString()} {...data} />
        ))}
      </Carousel>
    </>
  )
}
